export const EditableMixin = {
  name: 'EditableMixin',
  mixins: [],
  props: {
    additionalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      routeName: '',
      editForm: {},
    }
  },
  computed: {

  },
  methods: {
    editButtonClicked(item) {
      this.editForm = item
      const modal = this.routeName.replace('admin/', '')
      return this.$bvModal.show(`modal-${modal}-edit`)
    },
    resetEditForm() {
      setTimeout(() => {
        this.editForm = {}
      }, 500)
    },
  },
}

export const _ = null
